
import { useState } from 'react';

export default function ServicesSection() {
  const [activeService, setActiveService] = useState(0);
  
  const services = [
    {
      title: '3D Immersive & Spatial Digital Displays',
      content: 'Ultra-premium installations in international airports, luxury malls, and highway plazas. Features LED wrapping, curved surfaces, and projection mapping for maximum impact and dwell time.',
      icon: 'ri-3d-view-line'
    },
    {
      title: 'Mega Highway Billboards (100-150m)',
      content: 'Large-format billboards along major expressways in GCC and Asia. Strategic placement at toll plazas and rest stops ensures extended exposure beyond fleeting glances.',
      icon: 'ri-roadster-line'
    },
    {
      title: 'Airport Approach Wraps & Façade LED',
      content: 'Premium airport advertising solutions including terminal wraps and LED façade installations. Perfect for targeting international business travelers and tourists.',
      icon: 'ri-plane-line'
    },
    {
      title: 'Cross-Border Campaign Management',
      content: 'End-to-end campaign coordination across GCC and Asian markets. From permit acquisition to cultural localization and performance measurement.',
      icon: 'ri-global-line'
    },
    {
      title: 'Digital OOH Analytics & Optimization',
      content: 'Advanced measurement solutions including foot-fall analysis, dwell-time tracking, QR-scan engagement, and geo-fence interactions for data-driven campaign optimization.',
      icon: 'ri-bar-chart-line'
    }
  ];

  return (
    <section id="services" className="py-16 sm:py-20 lg:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 sm:mb-16 lg:mb-20">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-light text-gray-900 mb-4 sm:mb-6">
            Our OOH Solutions
          </h2>
          <p className="text-lg sm:text-xl lg:text-2xl text-gray-600 font-light max-w-3xl mx-auto leading-relaxed">
            Five specialized outdoor advertising formats designed for maximum impact across GCC and Asian markets.
          </p>
        </div>
        
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 sm:gap-12 lg:gap-16 items-start">
          {/* Mobile: Stack layout, Desktop: Side by side */}
          <div className="space-y-4 sm:space-y-6 order-2 lg:order-1">
            {services.map((service, index) => (
              <div key={index} className="border border-gray-200 rounded-xl p-4 sm:p-6 hover:shadow-lg transition-all duration-300">
                <button
                  onClick={() => setActiveService(activeService === index ? -1 : index)}
                  className="w-full text-left flex items-start justify-between cursor-pointer"
                >
                  <div className="flex items-start gap-3 sm:gap-4 flex-1">
                    <div className="w-10 h-10 sm:w-12 sm:h-12 bg-blue-100 rounded-lg flex items-center justify-center flex-shrink-0 mt-1">
                      <i className={`${service.icon} text-blue-600 text-lg sm:text-xl`}></i>
                    </div>
                    <div className="flex-1">
                      <h3 className="text-lg sm:text-xl lg:text-2xl font-medium text-gray-900 mb-2 leading-tight">
                        {service.title}
                      </h3>
                      {activeService === index && (
                        <p className="text-gray-600 font-light leading-relaxed text-base sm:text-lg">
                          {service.content}
                        </p>
                      )}
                    </div>
                  </div>
                  <div className="ml-4 flex-shrink-0">
                    <i className={`ri-${activeService === index ? 'subtract' : 'add'}-line text-gray-600 text-xl sm:text-2xl`}></i>
                  </div>
                </button>
              </div>
            ))}
          </div>
          
          <div className="relative order-1 lg:order-2 mb-8 lg:mb-0">
            <div className="sticky top-8">
              <img
                src="https://public.readdy.ai/ai/img_res/d286759de0a341ff633c836af0ef339b.jpg"
                alt="OOH advertising team collaboration"
                className="w-full h-64 sm:h-80 lg:h-96 object-cover object-top rounded-2xl shadow-2xl"
              />
              
              {/* Floating Stats for Mobile */}
              <div className="absolute -bottom-4 -left-4 bg-white rounded-xl p-4 shadow-lg border lg:hidden">
                <div className="text-2xl font-bold text-blue-600">5+</div>
                <div className="text-sm text-gray-600">Solutions</div>
              </div>
              
              <div className="absolute -bottom-4 -right-4 bg-white rounded-xl p-4 shadow-lg border lg:hidden">
                <div className="text-2xl font-bold text-green-600">24/7</div>
                <div className="text-sm text-gray-600">Support</div>
              </div>
            </div>
          </div>
        </div>

        {/* Mobile CTA Section */}
        <div className="mt-12 sm:mt-16 text-center lg:hidden">
          <button className="bg-blue-600 text-white px-8 py-4 rounded-xl font-semibold text-lg hover:bg-blue-700 transition-colors cursor-pointer">
            Get Started Today
          </button>
        </div>
      </div>
    </section>
  );
}
